import { useTranslation } from 'react-i18next'

import configurationServices from '@/configuration/services/services'

const useAddImage = ({ merchantId, setToastInfo, editorRef }) => {
  const { t } = useTranslation()

  const onImageUpload = async file => {
    const formData = new FormData()
    formData.append('image', file)

    try {
      const { data } = await configurationServices.uploadMerchantEmailTemplateImage({
        merchantId,
        formData,
      })
      return data.image
    } catch {
      setToastInfo({ show: true, message: t('Error al subir la imagen'), type: 'error' })
      return null
    }
  }

  const triggerImageUpload = () => {
    if (editorRef.current) {
      const toolbar = editorRef.current.getModule('toolbar')
      toolbar.handlers.image.call(toolbar)
    }
  }

  return { onImageUpload, triggerImageUpload }
}

export default useAddImage
